import { PropertyType } from 'esa-ui-library/lib/types';
import { map } from 'lodash';
import { formatToISO } from '../../../common';

export const getFiltersUrl = (filters: PropertyType[]): string => {
	const urlFragments: string[] = [];

	filters.forEach((f) => {
		const value = f.name == 'start_date' || f.name == 'end_date' ? formatToISO(f.value) : f.value;
		urlFragments.push(`${f.name}=${value}`);
	});
	const fitlersQuery = `?${urlFragments.join('&')}&only_esa=1`;
	return fitlersQuery;
};

export const getChartColors = (length: number): string[] => {
	const colors = [
		'#8BC642',
		'#fff',
		'#ADADAD',
		'#8E8E8E',
		'#78db78',
		'#dbdfe9',
		'#a2a9bc',
		'#ebffca',
		'#c9c9c9',
		'#ee9e00',
		'#11670f',
		'#212a3d',
		'#fdec94',
		'#090c14',
	];
	return colors.slice(0, length);
};

export const mapChartResponse = (data: PropertyType, label: string, colorsNum?: number): PropertyType => {
	const chartData: PropertyType = {};
	const extractedDataset = map(data.datasets, 'data');
	chartData.labels = data.labels;
	chartData.datasets = [
		{
			label: label,
			backgroundColor: getChartColors(colorsNum || data?.labels?.length || 0),
			data: [].concat(...extractedDataset),
		},
	];
	return chartData;
};

export const mapDoughnutChartResponse = (data: PropertyType, label: string, colorsNum?: number): PropertyType => {
	const chartData: PropertyType = {};
	const extractedDataset: number[][] = Object.values(data.datasets) as number[][];
	chartData.labels = Object.keys(data.datasets);
	chartData.datasets = [
		{
			label: label,
			backgroundColor: getChartColors(colorsNum || data?.labels?.length || 0),
			data: extractedDataset.flat(),
		},
	];
	return chartData;
};

export const mapBarChartResponse = (data: PropertyType, label: string, colorsNum?: number): PropertyType => {
	const chartData: PropertyType = {};
	const extractedDataset: number[] = [];
	const labels: string[] = [];

	Object.keys(data.values).map((key) => {
		const setObject = data.values[key];
		labels.push(setObject.label);
		extractedDataset.push(setObject.data[0]);
	});

	chartData.labels = [...labels];
	chartData.datasets = [
		{
			label: label,
			backgroundColor: getChartColors(colorsNum || data?.labels?.length || 0),
			data: [...extractedDataset],
		},
	];
	return chartData;
};
